import MainLayout from "../components/layout/MainLayout";
import ModalLoadingFull from "../components/modals/ModalLoadingFull";
import { findGetParameter } from "../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../global/environmentVariables";
import ArmyListSearch from "../pages/lists/ArmyListSearch";
import StoreAccount from "../pages/store/StoreAccount";
import Account from "../pages/user/Account";
import LoginRedirect from "../pages/user/Login/LoginRedirect";
import NotFound from "../pages/utility/NotFound";
const IS_DEV = getEnvironmentVariable("IS_DEV") === "true";
const IS_DEMO = getEnvironmentVariable("IS_DEMO") === "true";
const SUPPORTS_CARD_DATABASE =
  getEnvironmentVariable("SUPPORTS_CARD_DATABASE") === "true";

export const accountRoutes = (authContext, itemsMiddle, setItemsMiddle) => {
  const forceLoginParam = findGetParameter("forceLogin");

  return [
    {
      path: "account",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "shop",
          element: authContext?.authState?.isAuthenticated ? (
            <StoreAccount />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "decks",
          element: SUPPORTS_CARD_DATABASE ? (
            authContext?.authState?.isAuthenticated ? (
              <ArmyListSearch userSearch heading="My Decks" />
            ) : (
              <LoginRedirect />
            )
          ) : (
            <NotFound />
          )
        },
        {
          path: "/account/",
          element: authContext?.authState?.isAuthenticated ? (
            <Account />
          ) : (
            <LoginRedirect />
          )
        }
      ]
    }
  ];
};
